import React, { useState, useEffect } from "react";
import immigetLogo from "../../images/home/navbar-logo.png";
import benyLogo from "../../images/logos/Beny-Logo.png";
import toggleIcon from "../../images/home/toggle-icon.svg";
import arrow from "../../images/home/header-responsive-arrow.svg";
import { Link } from "react-router-dom";
import { IoMdClose } from "react-icons/io";
import { IoIosArrowDown } from "react-icons/io";
import logoResponsive from "../../images/home/navbar-logo.png";

const BenyHeader = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [activeMegaMenu, setActiveMegaMenu] = useState(null);
  const [menuCloseTimeout, setMenuCloseTimeout] = useState(null);

  const toggleDropdown = (dropdown) => {
    setActiveDropdown(activeDropdown === dropdown ? null : dropdown);
  };

  const handleMegaMenuEnter = (menu) => {
    // Clear any existing timeout
    if (menuCloseTimeout) {
      clearTimeout(menuCloseTimeout);
      setMenuCloseTimeout(null);
    }
    setActiveMegaMenu(menu);
  };

  const handleMegaMenuLeave = () => {
    // Add a small delay before closing the menu
    const timeout = setTimeout(() => {
      setActiveMegaMenu(null);
    }, 100);
    setMenuCloseTimeout(timeout);
  };

  // Work Visas Menu
  const workVisasLinks = [
    { name: "Skills in Demand SID (Subclass 482)", url: "/skills-in-demand-visa-482", isNew: false },
    { name: "Employer Nomination Scheme (Subclass 186)", url: "/subclass-186-visa-australia-consultants" },
    { name: "Skilled Employer Sponsored Regional (Subclass 494)", url: "/subclass-494-visa-australia-consultants" },
    { name: "Training Visa (Subclass 407)", url: "/subclass-407-visa-australia-consultants" },
    { name: "Working Holiday Visa (Subclass 417, 462)", url: "/working-holiday-visa", isNew: false },
    { name: "Temporary Work Short Stay (Subclass 400)", url: "/subclass-400-visa-australia-consultants" },
  ];

  // Skilled Visas Menu
  const skilledVisasLinks = [
    { name: "Skill Select – Independent (Subclass 189)", url: "/subclass-189-visa-australia-consultants" },
    { name: "Skill Select – Nominated (Subclass 190)", url: "/subclass-190-visa-australia-consultants" },
    { name: "Skill Select – Working in Regional (Subclass 491)", url: "/subclass-491-visa-australia-consultants" },
    { name: "Permanent Residence Regional (Subclass 191)", url: "/permanent-residence-regional-191", isNew: false },
    { name: "Temporary Graduate (Subclass 485)", url: "/subclass-485-visa-australia-consultants" },
    { name: "Skills Assessment", url: "/skill-assessment-australia-consultants" },
  ];

  // Family & Spouse Menu
  const familySpouseLinks = [
    { name: "Visitor Visa (Subclass 600, 601, 651)", url: "/australia-visitor-visa-consultants" },
    { name: "Partner Visa (Subclass 820/801 & 309/100)", url: "/partner-visa-australia" },
    { name: "Prospective Marriage/Fiancé (Subclass 300)", url: "/prospective-marriage-visa-300", isNew: false },
    { name: "Parent Visa (Subclass 103, 143)", url: "/subclass-143-parent-visa-australia-consultants" },
    { name: "Child Visa (Subclass 101, 102 & 802)", url: "/child-visa", isNew: false },
    { name: "Relatives (Subclass 116, 836, 117, 115)", url: "/relatives-visa", isNew: false },
    { name: "New Zealand to AU (Subclass 189, 461, 444)", url: "/new-zealand-to-au", isNew: false },
    { name: "Resident Return (Subclass 155, 157)", url: "/resident-return-visa", isNew: false },
    { name: "Citizenship", url: "/citizenship", isNew: false },
  ];

  // Study in Australia Menu
  const studyAustraliaLinks = [
    { name: "Student Visa (Subclass 500)", url: "/subclass-500-student-visa-australia-consultants" },
    { name: "Trade Courses", url: "/trade-courses", isNew: false },
  ];

  // Appeals & Waivers Menu
  const appealsWaiversLinks = [
    { name: "Visa Refusal Appeal", url: "/visa-refusal-appeal", isNew: false },
    { name: "AAT Review", url: "/aat-review", isNew: false },
    { name: "Visa Cancellations", url: "/visa-cancellations", isNew: false },
  ];

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  // Cleanup timeout on component unmount
  useEffect(() => {
    return () => {
      if (menuCloseTimeout) {
        clearTimeout(menuCloseTimeout);
      }
    };
  }, [menuCloseTimeout]);

  return (
    <header style={{ backgroundColor: "#F4FFFC" }} className="relative">
      <div className="container max-w-[1440px] mx-auto py-6 lg:py-4 px-4 xl:px-14">
        <div className="flex justify-between items-center">
          {/* Logo Section - Now with both logos */}
          <div className="lg:flex hidden items-center gap-2">
            <Link to="/">
              <img src={immigetLogo} alt="Immiget Global Logo" className="w-[140px] h-[53px]" />
            </Link>
            <div className="h-10 w-[1px] bg-gray-300"></div>
            <img src={benyLogo} alt="Beny Logo" className="h-8" />
          </div>

          {/* Mobile Logos */}
          <div className="lg:hidden flex items-center gap-2">
            <Link to="/">
              <img 
                src={logoResponsive} 
                alt="Immiget Global Logo" 
                className="w-[126px] h-[73px]" 
              />
            </Link>
            <div className="h-8 w-[1px] bg-gray-300"></div>
            <img src={benyLogo} alt="Beny Logo" className="h-11" />
          </div>

          <div className="hidden lg:flex w-full max-w-[1000px] rounded-[67px] px-2 xl:px-6 py-4 space-x-4 justify-around items-center relative">
            {/* Work Visas Mega Menu */}
            <div
              className="relative"
              onMouseEnter={() => handleMegaMenuEnter('workVisas')}
              onMouseLeave={handleMegaMenuLeave}
            >
              <button
                className="text-blue hellix-font text-[15px] font-semibold flex items-center gap-1"
              >
                For Employers
                <IoIosArrowDown className={`nav-arrow transition-transform duration-300 ${activeMegaMenu === 'workVisas' ? 'rotate-180' : ''}`} />
              </button>
            </div>

            {/* Skilled Visas Mega Menu */}
            <div
              className="relative"
              onMouseEnter={() => handleMegaMenuEnter('skilledVisas')}
              onMouseLeave={handleMegaMenuLeave}
            >
              <button
                className="text-blue hellix-font text-[15px] font-semibold flex items-center gap-1"
              >
                Skilled Visas
                <IoIosArrowDown className={`nav-arrow transition-transform duration-300 ${activeMegaMenu === 'skilledVisas' ? 'rotate-180' : ''}`} />
              </button>
            </div>

            {/* Family & Spouse Mega Menu */}
            <div
              className="relative"
              onMouseEnter={() => handleMegaMenuEnter('familySpouse')}
              onMouseLeave={handleMegaMenuLeave}
            >
              <button
                className="text-blue hellix-font text-[15px] font-semibold flex items-center gap-1"
              >
                Family & Spouse
                <IoIosArrowDown className={`nav-arrow transition-transform duration-300 ${activeMegaMenu === 'familySpouse' ? 'rotate-180' : ''}`} />
              </button>
            </div>

            {/* Study in Australia Mega Menu */}
            <div
              className="relative"
              onMouseEnter={() => handleMegaMenuEnter('studyAustralia')}
              onMouseLeave={handleMegaMenuLeave}
            >
              <button
                className="text-blue hellix-font text-[15px] font-semibold flex items-center gap-1"
              >
                Study in Australia
                <IoIosArrowDown className={`nav-arrow transition-transform duration-300 ${activeMegaMenu === 'studyAustralia' ? 'rotate-180' : ''}`} />
              </button>
            </div>

            {/* Appeals & Waivers Mega Menu */}
            <div
              className="relative"
              onMouseEnter={() => handleMegaMenuEnter('appealsWaivers')}
              onMouseLeave={handleMegaMenuLeave}
            >
              <button
                className="text-blue hellix-font text-[15px] font-semibold flex items-center gap-1"
              >
                Appeals & Waivers
                <IoIosArrowDown className={`nav-arrow transition-transform duration-300 ${activeMegaMenu === 'appealsWaivers' ? 'rotate-180' : ''}`} />
              </button>
            </div>

            <Link
              to="/news"
              className="text-blue hellix-font text-[15px] font-semibold"
            >
              News
            </Link>
            <Link
              to="/best-migration-australia-consultants"
              className="text-blue hellix-font text-[15px] font-semibold"
            >
              About Us
            </Link>
          </div>

          {/* Mega Menu Dropdowns */}
          {activeMegaMenu && (
            <div
              className="mega-menu absolute left-0 w-full bg-white shadow-2xl border-t-4 border-blue z-50 py-6"
              onMouseEnter={() => handleMegaMenuEnter(activeMegaMenu)}
              onMouseLeave={handleMegaMenuLeave}
              style={{ 
                backgroundColor: "#F4FFFC",
                top: 'calc(100% - 4px)' // Small overlap to bridge the gap
              }}
            >
              <div className="container max-w-[1200px] mx-auto px-4">
                {activeMegaMenu === 'workVisas' && (
                  <div>
                    <h3 className="text-blue hellix-font text-xl font-bold mb-6 text-center">For Employers</h3>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-4">
                      {workVisasLinks.map((link, index) => (
                        <div key={index} className="mega-menu-item">
                          <Link
                            to={link.url}
                            className="block text-blue hellix-font text-[15px] font-medium transition-all py-2 px-3 rounded-lg"
                          >
                            {link.name} {link.isNew && <span className="text-xs bg-blue text-white px-2 py-1 rounded ml-2">New</span>}
                          </Link>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
                
                {activeMegaMenu === 'skilledVisas' && (
                  <div>
                    <h3 className="text-blue hellix-font text-xl font-bold mb-6 text-center">Skilled Visas</h3>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-4">
                      {skilledVisasLinks.map((link, index) => (
                        <div key={index} className="mega-menu-item">
                          <Link
                            to={link.url}
                            className="block text-blue hellix-font text-[15px] font-medium transition-all py-2 px-3 rounded-lg"
                          >
                            {link.name} {link.isNew && <span className="text-xs bg-blue text-white px-2 py-1 rounded ml-2">New</span>}
                          </Link>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
                
                {activeMegaMenu === 'familySpouse' && (
                  <div>
                    <h3 className="text-blue hellix-font text-xl font-bold mb-6 text-center">Family & Spouse</h3>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-x-6 gap-y-3">
                      {familySpouseLinks.map((link, index) => (
                        <div key={index} className="mega-menu-item">
                          <Link
                            to={link.url}
                            className="block text-blue hellix-font text-[14px] font-medium transition-all py-2 px-3 rounded-lg"
                          >
                            {link.name} {link.isNew && <span className="text-xs bg-blue text-white px-2 py-1 rounded ml-1">New</span>}
                          </Link>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
                
                {activeMegaMenu === 'studyAustralia' && (
                  <div>
                    <h3 className="text-blue hellix-font text-xl font-bold mb-6 text-center">Study in Australia</h3>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-4">
                      {studyAustraliaLinks.map((link, index) => (
                        <div key={index} className="mega-menu-item">
                          <Link
                            to={link.url}
                            className="block text-blue hellix-font text-[15px] font-medium transition-all py-2 px-3 rounded-lg"
                          >
                            {link.name} {link.isNew && <span className="text-xs bg-blue text-white px-2 py-1 rounded ml-2">New</span>}
                          </Link>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
                
                {activeMegaMenu === 'appealsWaivers' && (
                  <div>
                    <h3 className="text-blue hellix-font text-xl font-bold mb-6 text-center">Appeals & Waivers</h3>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-4">
                      {appealsWaiversLinks.map((link, index) => (
                        <div key={index} className="mega-menu-item">
                          <Link
                            to={link.url}
                            className="block text-blue hellix-font text-[15px] font-medium transition-all py-2 px-3 rounded-lg"
                          >
                            {link.name} {link.isNew && <span className="text-xs bg-blue text-white px-2 py-1 rounded ml-2">New</span>}
                          </Link>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}

          <div
            className={`lg:hidden mt-12 bg-custom-gradients absolute top-16 left-0 w-full bg-white rounded-b-lg transition-all duration-300 ease-in-out ${
              isMenuOpen ? "block" : "hidden"
            }`}
          >
            <div className="flex flex-col items-left p-4 space-y-4">
              {/* Work Visas Dropdown */}
              <div>
                <button
                  className="w-full text-left text-white hellix-font text-[15px] font-semibold hover:underline transition-all flex items-center gap-1"
                  onClick={() => toggleDropdown("workVisas")}
                >
                  For Employers
                  <IoIosArrowDown className={`transition-transform duration-300 ${activeDropdown === 'workVisas' ? 'rotate-180' : ''}`} />
                </button>
                <div
                  className={`transition-all duration-500 overflow-hidden ${
                    activeDropdown === "workVisas" ? "max-h-screen" : "max-h-0"
                  }`}
                >
                  <div className="pl-4 space-y-2 pt-2">
                    {workVisasLinks.map((link, index) => (
                      <Link
                        key={index}
                        to={link.url}
                        className="block text-white hellix-font text-[15px] font-medium hover:underline transition-all"
                        onClick={closeMenu}
                      >
                        {link.name}
                      </Link>
                    ))}
                  </div>
                </div>
              </div>

              {/* Skilled Visas Dropdown */}
              <div>
                <button
                  className="w-full text-left text-white hellix-font text-[15px] font-semibold hover:underline transition-all flex items-center gap-1"
                  onClick={() => toggleDropdown("skilledVisas")}
                >
                  Skilled Visas
                  <IoIosArrowDown className={`transition-transform duration-300 ${activeDropdown === 'skilledVisas' ? 'rotate-180' : ''}`} />
                </button>
                <div
                  className={`transition-all duration-500 overflow-hidden ${
                    activeDropdown === "skilledVisas" ? "max-h-screen" : "max-h-0"
                  }`}
                >
                  <div className="pl-4 space-y-2 pt-2">
                    {skilledVisasLinks.map((link, index) => (
                      <Link
                        key={index}
                        to={link.url}
                        className="block text-white hellix-font text-[15px] font-medium hover:underline transition-all"
                        onClick={closeMenu}
                      >
                        {link.name}
                      </Link>
                    ))}
                  </div>
                </div>
              </div>

              {/* Family & Spouse Dropdown */}
              <div>
                <button
                  className="w-full text-left text-white hellix-font text-[15px] font-semibold hover:underline transition-all flex items-center gap-1"
                  onClick={() => toggleDropdown("familySpouse")}
                >
                  Family & Spouse
                  <IoIosArrowDown className={`transition-transform duration-300 ${activeDropdown === 'familySpouse' ? 'rotate-180' : ''}`} />
                </button>
                <div
                  className={`transition-all duration-500 overflow-hidden ${
                    activeDropdown === "familySpouse" ? "max-h-screen" : "max-h-0"
                  }`}
                >
                  <div className="pl-4 space-y-2 pt-2">
                    {familySpouseLinks.map((link, index) => (
                      <Link
                        key={index}
                        to={link.url}
                        className="block text-white hellix-font text-[15px] font-medium hover:underline transition-all"
                        onClick={closeMenu}
                      >
                        {link.name}
                      </Link>
                    ))}
                  </div>
                </div>
              </div>

              {/* Study in Australia Dropdown */}
              <div>
                <button
                  className="w-full text-left text-white hellix-font text-[15px] font-semibold hover:underline transition-all flex items-center gap-1"
                  onClick={() => toggleDropdown("studyAustralia")}
                >
                  Study in Australia
                  <IoIosArrowDown className={`transition-transform duration-300 ${activeDropdown === 'studyAustralia' ? 'rotate-180' : ''}`} />
                </button>
                <div
                  className={`transition-all duration-500 overflow-hidden ${
                    activeDropdown === "studyAustralia" ? "max-h-screen" : "max-h-0"
                  }`}
                >
                  <div className="pl-4 space-y-2 pt-2">
                    {studyAustraliaLinks.map((link, index) => (
                      <Link
                        key={index}
                        to={link.url}
                        className="block text-white hellix-font text-[15px] font-medium hover:underline transition-all"
                        onClick={closeMenu}
                      >
                        {link.name}
                      </Link>
                    ))}
                  </div>
                </div>
              </div>

              {/* Appeals & Waivers Dropdown */}
              <div>
                <button
                  className="w-full text-left text-white hellix-font text-[15px] font-semibold hover:underline transition-all flex items-center gap-1"
                  onClick={() => toggleDropdown("appealsWaivers")}
                >
                  Appeals & Waivers
                  <IoIosArrowDown className={`transition-transform duration-300 ${activeDropdown === 'appealsWaivers' ? 'rotate-180' : ''}`} />
                </button>
                <div
                  className={`transition-all duration-500 overflow-hidden ${
                    activeDropdown === "appealsWaivers" ? "max-h-screen" : "max-h-0"
                  }`}
                >
                  <div className="pl-4 space-y-2 pt-2">
                    {appealsWaiversLinks.map((link, index) => (
                      <Link
                        key={index}
                        to={link.url}
                        className="block text-white hellix-font text-[15px] font-medium hover:underline transition-all"
                        onClick={closeMenu}
                      >
                        {link.name}
                      </Link>
                    ))}
                  </div>
                </div>
              </div>

              {/* Other Links */}
              <Link
                to="/news"
                className="text-white hellix-font text-[15px] font-semibold hover:underline transition-all"
                onClick={closeMenu}
              >
                News
              </Link>
              <Link
                to="/best-migration-australia-consultants"
                className="text-white hellix-font text-[15px] font-semibold hover:underline transition-all"
                onClick={closeMenu}
              >
                About Us
              </Link>
            </div>
          </div>

          <div className="hidden lg:block">
            <button className="relative w-[144px] xl:w-[169px] text-center justify-center group text-[#004b6b] hellix-font font-bold text-[15px] h-[44px] xl:h-[52px] rounded-[28px] flex items-center space-x-2 border-2 border-[#004b6b] overflow-hidden">
              <span className="absolute inset-0 bg-white transform scale-x-0 group-hover:scale-x-100 transition-all duration-500 ease-out origin-left z-0"></span>
              <span className="relative z-10 group-hover:text-[#004b6b] transition-colors duration-300 ease-in">
                <Link to="/immigration-office-australia-consultants">
                  Contact Us
                </Link>
              </span>
              <img
                src={arrow}
                alt="Arrow Icon"
                className="relative z-10 w-4 h-4 transition-all duration-300 ease-out group-hover:translate-x-2 group-hover:brightness-150"
              />
            </button>
          </div>

          <div className="lg:hidden flex gap-4">
            <div className="flex items-center ">
              <button className="relative w-[144px]  text-center justify-center group text-[#004b6b] hellix-font font-bold text-[15px] h-[44px]  rounded-[28px] flex items-center space-x-2 border-2 border-blue overflow-hidden">
                <span className="absolute inset-0 bg-white transform scale-x-0 group-hover:scale-x-100 transition-all duration-1000 ease-in-out origin-left z-0"></span>
                <span className="relative z-10 group-hover:text-blue transition-colors duration-700 ease-in">
                  <Link to="/immigration-office-australia-consultants">
                    Contact Us
                  </Link>
                </span>
                <img
                  src={arrow}
                  alt="Arrow Icon"
                  className="relative z-10 transition-all duration-500 ease-in "
                />
              </button>
            </div>
            <div
              className=" flex items-center text-black text-2xl font-bold cursor-pointer"
              onClick={toggleMenu}
            >
              {isMenuOpen ? (
                <IoMdClose className="text-3xl" />
              ) : (
                <img src={toggleIcon} alt="Toggle Icon" />
              )}
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default BenyHeader;